<template>
  <div @mousedown="toggleDropdown" :class="{ 'disabled': disabled }">
    <div class="select-selected">
      {{ selected }}
      <span :class="isOpen ? 'arrow-up' : 'arrow-down'"
      class="arrow"></span>
    </div>
    <div v-show="isOpen && !disabled" class="select-items" @mousedown.stop>
      <div
        v-for="(option, index) in options"
        :key="index"
        @click="selectOption(option)"
        :class="{'selected': option === selected}"
      >
        {{ option }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomSelect',
  props: {
    options: {
      type: Array,
      required: true
    },
    value: [String, Number],
    disabled: {
      type: Boolean,
      default: false
    },
    defaultValue: {
      type: [String, Number],
      default: null
    }
  },
  data () {
    return {
      selected: this.defaultValue !== null ? this.defaultValue : this.value,
      isOpen: false
    }
  },
  watch: {
    value (newValue) {
      this.selected = newValue
    }
  },
  methods: {
    toggleDropdown () {
      if (!this.disabled) {
        this.isOpen = !this.isOpen
        // Make sure the selected option is always the first visible item
        this.$nextTick(() => {
          const selectedOptionIndex = this.options.indexOf(this.selected)
          const selectItems = this.$el.querySelector('.select-items')
          const selectedOption = selectItems.children[selectedOptionIndex]
          if (selectedOption) {
            // Set the selected option as the first item in the dropdown
            selectItems.scrollTop = selectedOption.offsetTop
          }
        })
      }
    },
    selectOption (option) {
      this.selected = option
      this.isOpen = false
      this.$emit('input', option)
      this.$emit('change', option)
    },
    closeAllSelect (event) {
      if (!this.$el.contains(event.target)) {
        this.isOpen = false
      }
    }
  },
  mounted () {
    document.addEventListener('mousedown', this.closeAllSelect)
  },
  beforeDestroy () {
    document.removeEventListener('mousedown', this.closeAllSelect)
  }
}
</script>

<style scoped>
.disabled {
  pointer-events: none;
  background: #ECEFF1;
}

.select-selected {
  cursor: pointer;
  padding: 8px 16px;
  border: 1px solid #ccc;
  height: 35px;
  display: grid;
  align-items: center;
  align-content: center;
  justify-content: start;
  border-radius: 8px;
}

.select-items {
  position: absolute;
  background-color: #f9f9f9;
  overflow-y: auto;
  border: 1px solid #ccc;
  z-index: 999;
  max-height: 37vh;
  min-width: 100%;
  scrollbar-width: thin;
  scrollbar-color: #ffc800 #f7f7f7;
  border-radius: 8px;
}

@media screen and (max-width: 575px) {
  .select-items {
    max-height: 22vh;
  }
}

.select-items div {
  padding: 8px 16px;
  cursor: pointer;
}

.select-items div:hover {
  background-color: #f0f0f0;
}

.select-items div.selected {
  background-color: #ffc800;
  color: white;
}

.arrow {
  position: absolute;
  right: 15px;
}

.arrow-up::before {
  content: '\25B2';
  margin-left: 5px;
}

.arrow-down::before {
  content: '\25BC';
  margin-left: 5px;
}
</style>
